
(function () {
  function hideEmptySpecRows() {
    document.querySelectorAll('dp-size-chart-block table').forEach(function (table) {
      table.querySelectorAll('tr').forEach(function (row) {
        const cells = Array.from(row.querySelectorAll('td'));

        if (cells.length < 2) return;

        const valueCells = cells.slice(1);

        const hasValue = valueCells.some(function (cell) {
          const text = cell.textContent
            .replace(/\u00a0/g, ' ')
            .trim();

          return text.length > 0 ||
            !!cell.querySelector('img, svg, a, video, iframe');
        });

        row.hidden = !hasValue;
        row.style.display = hasValue ? '' : 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptySpecRows);
  } else {
    hideEmptySpecRows();
  }
})();
